export enum EventType {
    Fault = 'Fault',
    DataOutage = 'DataOutage',
    PpaBreach = 'PpaBreach',
    InService = 'InService',
    CustomAction = 'CustomAction',
    Performance = 'Performance',
    RemitBreach = 'RemitBreach',
    FpnBreach = 'FpnBreach',
}

const eventTypeDisplay: Record<EventType, string> = {
    Fault: 'Fault',
    DataOutage:'Data Outage',
    PpaBreach: 'PPA Breach',
    InService: 'In Service',
    CustomAction: 'Custom Action',
    Performance: 'Performance',
    RemitBreach: 'REMIT Breach',
    FpnBreach: 'FPN Breach',
  };

export const formatTypeForDisplay = (type: EventType) => {
    return eventTypeDisplay[type];
};
